import { clearFilterParams, useCleanFilterForRequest } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import { path } from 'ramda'
import React from 'react'

import { checklistsClient } from '../../utils/apollo/api'
import { usePromiseQuery } from '../../utils/apollo/_helpers/promiseQuery'
import LazySelectAllLinkApollo from '../../components/actions/LazySelectAllLinkApollo'

const QUERY = gql`
  query Checklists($search: String, $filter: ChecklistFilter) {
    checklists(limit: 900000, search: $search, filter: $filter) {
      id
    }
  }
`

export const useGetAllChecklists = () => {
  const filter = useCleanFilterForRequest()
  const call = usePromiseQuery(QUERY, {
    variables: { filter },
    client: checklistsClient
  })
  return () => call().then(path(['data', 'checklists']))
}

//TODO: Use useGetAllChecklists func
const SelectAllChecklistsLink = ({ search, filter, ...props }) => {
  return (
    <LazySelectAllLinkApollo
      query={QUERY}
      variables={{ search, filter: clearFilterParams(filter || {}) }}
      client={checklistsClient}
      {...props}
    />
  )
}

export default SelectAllChecklistsLink
